import { maskAccountNumber } from '@ally/aos-utils'

export function createDebtPlanLinkAriaLabel(
  nameOrNickName: string,
  accountNumber: string,
): string {
  return `${nameOrNickName} debt plan ending in ${maskAccountNumber(
    accountNumber,
    'none',
  )}`
}
